<styles-icon-value icon="star">
  <ng-content></ng-content>
</styles-icon-value>
@if (isCore) {
  <div class="core-wrapper" [matTooltip]="generateUnitsTip(element)">core</div>
}
